module.exports = __webpack_public_path__ + "img/2.56dc6c4f.png";